var Data = {
  charts: {
    result: null,
    error: "",
    fetch: async (options={}) => {
      const {
        chart
      } = options
      if(chart && chart.endsWith('.png')) {
        const charts = [{ src: encodeURI(`http://covid.podvision.net${chart}`) }]
        const items = { charts }
        Data.charts.result = items
        return items
      }
      try {
        const items = await m.request({
          method: "GET",
          url: "/chart/",
          params: { href: chart }
        })
        items.charts = items.charts.filter(chart => {
          const { src } = chart
          const urlSplit = src.split('/charts/country/')
          const bigChart = !urlSplit[urlSplit.length-1].includes('/')
          // return src.replace(/\D/g, '').length < 3 && !src.includes('/charts/country/')
          return src.replace(/\D/g, '').length < 3 && !bigChart
        })
        Data.charts.result = items
        return items
      } catch(e) {
        Data.charts.error = e.message
        throw e
      }
    }
  },
}

export { Data }
